import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { QuotePrice } from '@root/entities/quote/ui'
import { InfoMessage } from '@root/shared/ui-kit'

import { WalletSwapDetailsTable } from './wallet-swap-details-table'

import type { WalletSwapDetailsTableProps } from './wallet-swap-details-table'
import type { ClassNameProps } from '@root/shared/react'

// TODO: Error styles

type Props = WalletSwapDetailsTableProps &
  ClassNameProps & {
    onRetryQuote: () => void
  }

export const WalletSwapDetails: React.FC<Props> = ({
  quoteState,
  baseCurrency,
  quoteCurrency,
  className,
  onRetryQuote,
  ...props
}) => {
  const { t } = useTranslation()

  if (AsyncStateN.isError(quoteState)) {
    return (
      <Root className={className}>
        <InfoMessage
          css={css`
            margin-top: 20px;
          `}
          intent="error"
          variant="bold"
          title={t('common.something-went-wrong')}
          onRetry={onRetryQuote}
        />
      </Root>
    )
  }

  return (
    <Root className={className}>
      <QuoteContainer>
        <QuotePrice
          baseCurrency={baseCurrency}
          quoteCurrency={quoteCurrency}
          quoteState={quoteState}
        />
      </QuoteContainer>
      <WalletSwapDetailsTable
        {...props}
        baseCurrency={baseCurrency}
        quoteCurrency={quoteCurrency}
        quoteState={quoteState}
      />
    </Root>
  )
}

const Root = styled.div`
  --swap-details-label-font-size: 14px;
  --swap-details-value-font-size: 14px;
  --swap-details-row-line-height: 20px;
  --swap-details-row-gap: 14px;

  margin-top: 12px;
  padding-bottom: 16px;
`

const QuoteContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`
